<!-- 教育背景 -->
<template>
  <div class="education">
    <h1 class="application-title">教育背景</h1>
    <div class="application-smart-title">
      Educational Background
    </div>
    <div class="application-smart-light-title">
      此部分内容要展示给你的导师，请尽量用英文填写，便于导师阅读
    </div>
    <div class="education-form">
      <Form ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="226">

        <div class="education-form-item">
          <FormItem label="Undergraduate University"
                    prop="university">
            <Input v-model="formValidate.university"
                   placeholder="e.g. Peking University"></Input>
          </FormItem>
          <FormItem label="Graduation Year"
                    prop="graduationYear">
            <Input v-model="formValidate.graduationYear"
                   placeholder="e.g. 2018"></Input>
          </FormItem>
          <FormItem label="Department"
                    prop="department">
            <Input v-model="formValidate.department"
                   placeholder="e.g. Physics Department"></Input>
          </FormItem>
        </div>

        <div class="education-form-item">
          <FormItem label="Program 01 "
                    prop="program1">
            <Input v-model="formValidate.program1"
                   placeholder="e.g. Physics"></Input>
          </FormItem>
          <FormItem label="Overall GPA Program 01 "
                    prop="program1OverallGPA">
            <Input v-model="formValidate.program1OverallGPA"
                   placeholder="e.g. 3.92"></Input>
          </FormItem>
          <FormItem label="GPA Scale"
                    prop="gpaScale">
            <Select v-model="formValidate.gpaScale"
                    placeholder="Select your city">
              <Option v-for="item in selectGPAScaleList"
                      :value="item.value"
                      :key="item.value">{{item.label }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="Rank Program 01"
                    prop="program1Rank">
            <Input v-model="formValidate.program1Rank"
                   placeholder="e.g. 1/45"></Input>
          </FormItem>
          <FormItem label="Ranking base"
                    prop="program1RankCount">
            <Input v-model="formValidate.program1RankCount"
                   placeholder="e.g. 1/45"></Input>
          </FormItem>
        </div>

        <div class="education-form-item">
          <FormItem label="Program 02 (if dual major) "
                    prop="program2">
            <Input v-model="formValidate.program2"
                   placeholder="e.g. Physics"></Input>
          </FormItem>
          <FormItem label="Overall GPA Program 02"
                    prop="program2OverallGPA">
            <Input v-model="formValidate.program2OverallGPA"
                   placeholder="e.g. 3.92"></Input>
          </FormItem>
          <FormItem label="Rank Program 02"
                    prop="program2Rank">
            <Input v-model="formValidate.program2Rank"
                   placeholder="e.g. 1/45"></Input>
          </FormItem>
        </div>

        <div class="education-form-item">
          <FormItem label="Program (minor) "
                    prop="minorProgram">
            <Input v-model="formValidate.minorProgram"
                   placeholder="e.g. Physics"></Input>
          </FormItem>
          <FormItem label="Minor GPA"
                    prop="minorGPA">
            <Input v-model="formValidate.minorGPA"
                   placeholder="e.g. 3.92"></Input>
          </FormItem>
        </div>

        <div class="education-form-item">
          <FormItem label="Your major GPA"
                    prop="majorGPA">
            <Input v-model="formValidate.majorGPA"
                   placeholder="e.g. 3.92"></Input>
          </FormItem>
          <FormItem label="Thesis Topic (If applicable)"
                    prop="thesisTopic">
            <Input v-model="formValidate.thesisTopic"
                   placeholder="e.g. 3.92"></Input>
          </FormItem>
        </div>

        <div class="education-form-item">
          <FormItem label="High School"
                    prop="highSchool">
            <Input v-model="formValidate.highSchool"
                   placeholder="e.g. Beida High School"></Input>
          </FormItem>
          <FormItem label="Graduation Year"
                    prop="highSchoolGraduationYear">
            <Input v-model="formValidate.highSchoolGraduationYear"
                   placeholder="e.g. 2018"></Input>
          </FormItem>
          <FormItem label="National College Entrance Exam (Gaokao) Rank"
                    prop="gaokaoRank"
                    class="label-max">
            <Input v-model="formValidate.gaokaoRank"
                   placeholder="e.g. 30"></Input>
          </FormItem>
        </div>

        <div class="education-form-item">
          <FormItem label="Other related info"
                    prop="notes">
            <Input v-model="formValidate.notes"
                   placeholder="e.g. Graduate university, major, GPA etc."
                   type="textarea"
                   :rows=5></Input>
          </FormItem>
        </div>
        <div class="sub-btn" v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </Form>
    </div>
  </div>
</template>




<script>
// less
import './application.less'
//  api
import { infoQueryEducational, infoModifyEducational } from '@/api/info'
import { validateYears, validateFloat, validateNumber } from '@/libs/validator'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: 'application-education',
  components: {},
  mixins: [isAllowEdit],
  data () {
    return {
      formValidate: {},
      ruleValidate: {
        university: [{ required: true, message: '这是必填项，还请填写' }],
        graduationYear: [{ required: true, message: '这是必填项，还请填写' }, { validator: validateYears }],
        department: [{ required: true, message: '这是必填项，还请填写' }],
        program1: [{ required: true, message: '这是必填项，还请填写' }],
        program1OverallGPA: [{ required: true, message: '这是必填项，还请填写' }, { validator: validateFloat, floatLength: 2 }],
        gpaScale: [{ required: true, message: '这是必填项，还请选择' }],
        program1Rank: [{ required: true, message: '这是必填项，还请填写' }, { validator: validateNumber }],
        program1RankCount: [{ required: true, message: '这是必填项，还请填写' }, { validator: validateNumber }],
        program2OverallGPA: [{ validator: validateFloat, floatLength: 2 }],
        program2Rank: [{ validator: validateNumber }],
        minorGPA: [{ validator: validateFloat, floatLength: 2 }],
        majorGPA: [{ required: true, message: '这是必填项，还请填写' }, { validator: validateFloat, floatLength: 2 }],
        highSchool: [{ required: true, message: '这是必填项，还请填写' }],
        highSchoolGraduationYear: [{ required: true, message: '这是必填项，还请填写' }, { validator: validateYears }],
        gaokaoRank: [{ required: true, message: '这是必填项，还请填写' }]
      },
      // GPAscale
      selectGPAScaleList: [
        {
          value: 'HUNDRED_MARK_SYSTEM',
          label: '100'
        },
        {
          value: 'TWELVE_POINT_SYSTEM',
          label: '12'
        },
        {
          value: 'FIVE_POINT_SYSTEM',
          label: '5'
        },
        {
          value: 'FOUR_POINT_FIVE_SYSTEM',
          label: '4.5'
        },
        {
          value: 'FOUR_POINT_THREE_SYSTEM',
          label: '4.3'
        },
        {
          value: 'FOUR_POINT_SYSTEM',
          label: '4'
        }
      ]
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      infoQueryEducational().then(res => {
        let data = res.data.model || {}
        this.formValidate = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          infoModifyEducational(data).then(res => {
            this.$zlr_message('保存成功', 'success')
            this.$router.push({
              name: 'application-exam-score'
            })
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
